import config from 'devextreme/core/config';
import { licenseKey } from './app/devextreme-license';
import deMessages from 'devextreme/localization/messages/de.json';
import { loadMessages, locale } from 'devextreme/localization';

config({ licenseKey });

loadMessages(deMessages);
loadMessages({
  de: {
    CheckState: 'Auswahlzustand',
    'dxCardView-selectAll': 'Alles auswählen',
    'dxDataGrid-ariaFilterCell': 'Nach eingegebenem Text filtern',
    'dxDataGrid-ariaSearchInGrid':
      'Datentabelle durchsuchen - Suchbegriff eingeben',
    'dxDataGrid-ariaSelectAll': 'Alles auswählen',
    'dxDiagram-commandSelectAll': 'Alles auswählen',
    'dxDropDownEditor-selectLabel': 'Auswählen',
    'dxList-listAriaLabel': 'Optionen',
    'dxList-selectAll-indeterminate': 'Teilweise ausgewählt',
    'dxList-selectAll-checked': 'Ausgewählt',
    'dxList-selectAll-notChecked': 'Nicht ausgewählt',
    'dxList-selectAll': 'Alles auswählen'
  }
});
locale('de');
